import React from 'react';
import PropTypes from 'prop-types';
// import * as _ from 'lodash';
import _ from 'lodash'
import { Row, Col } from 'reactstrap';
import styled from 'styled-components';
import Clearfix from 'components/elements/clearfix';
import { convertDateFromSeverToString as convertDate } from 'utils/fnUtil';
import PageLockHOC from 'hoc/pageLock';
import { FIELDS } from '../constants';

const LabelContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  // justify-content: flex-end;
`;

class RowValue extends React.Component {
  static propTypes = {
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  };

  state = {};

  async componentWillMount() { }

  render() {
    return (
      <div>
        <Row>
          <Col xs={3}>{this.props.label}</Col>
          <Col xs={8}>{this.props.value}</Col>
        </Row>
        <Clearfix height={8} />
      </div>
    );
  }
}

@PageLockHOC(['facility.view'])
export default class ChiTietCosoView extends React.Component {
  static propTypes = {
    initialValue: PropTypes.object,
  };
  state = {};

  async componentWillMount() { }

  getInitialValue = (keyPath, defaultValue = '') => {
    return _.get(this.props.initialValue, keyPath, defaultValue);
  };

  render() {
    return (
      <div style={{ width: '100%' }}>
        <React.Fragment>
          <Row>
            <Col xs={3}>
              <LabelContainer>
                <b>Giấy chứng nhận đầu tư</b>
              </LabelContainer>
            </Col>
          </Row>
          <RowValue
            label='Số giấy phép'
            value={this.getInitialValue('InvestmentLicenseNumber')}
          />
          <RowValue
            label='Ngày cấp lần đầu'
            value={convertDate(
              this.getInitialValue('InvestmentLicenseIssueDateFirst')
            )}
          />
          <RowValue
            label='Ngày cấp lần gần nhất'
            value={convertDate(
              this.getInitialValue('InvestmentLicenseIssueDateLast')
            )}
          />
        </React.Fragment>

        <React.Fragment>
          <Row>
            <Col xs={3}>
              <LabelContainer>
                <b>Giấy chứng nhận đăng ký doanh nghiệp</b>
              </LabelContainer>
            </Col>
          </Row>
          <RowValue
            label='Số giấy phép'
            value={this.getInitialValue('BusinessLicenseNumber')}
          />
          <RowValue
            label='Ngày cấp lần đầu'
            value={convertDate(
              this.getInitialValue('BusinessLicenseIssueDateFirst')
            )}
          />
          <RowValue
            label='Ngày cấp lần gần nhất'
            value={convertDate(
              this.getInitialValue('BusinessLicenseIssueDateLast')
            )}
          />
        </React.Fragment>

        <React.Fragment>
          <Row>
            <Col xs={3}>
              <LabelContainer>
                <b>Thông tin báo cáo chất thải nguy hại</b>
              </LabelContainer>
            </Col>
          </Row>
          <RowValue
            label='Mã số QLCTNH'
            value={this.getInitialValue(FIELDS.reportHazardousWasteCode)}
          />
          <RowValue
            label='Ngày cấp'
            value={convertDate(
              this.getInitialValue(FIELDS.reportHazardousWasteDate)
            )}
          />
          <RowValue
            label='Cấp lần'
            value={this.getInitialValue(
              FIELDS.reportHazardousWasteAllocationTimes
            )}
          />
          <RowValue
            label='Ngày cấp lại'
            value={convertDate(
              this.getInitialValue(FIELDS.reportHazardousWasteDateRenew)
            )}
          />
          <RowValue
            label='Hình thức xử lý'
            value={
              _.get(this.getInitialValue(FIELDS.reportHazardousWasteFormProcessing), 'Name', '')
            }
          />
          <RowValue
            label='Khối lượng đăng ký (kg)'
            value={this.getInitialValue(FIELDS.reportHazardousWasteMass)}
          />
        </React.Fragment>

        <React.Fragment>
          <Row>
            <Col xs={3}>
              <LabelContainer>
                <b>Thông tin khác</b>
              </LabelContainer>
            </Col>
          </Row>
          <RowValue
            label='Hình thức sở hữu'
            value={this.getInitialValue('ownership.Name')}
          />
          <RowValue
            label='Năm bắt đầu hoạt động'
            value={this.getInitialValue('YearsOfOperation')}
          />
          <RowValue
            label='Số lượng công nhân viên'
            value={this.getInitialValue('Employees')}
          />
          <RowValue
            label='Công suất'
            value={this.getInitialValue('Capacity')}
          />
          <RowValue
            label='Quy trình sản xuất'
            value={this.getInitialValue('ProductDesc')}
          />
          <RowValue label='Nhiên liệu' value={this.getInitialValue('Fuel')} />
          <RowValue
            label='Số ngày làm việc trong tháng'
            value={this.getInitialValue('WorkingDaysMonth')}
          />
          <RowValue
            label='Số ngày làm việc/năm'
            value={this.getInitialValue('WorkingDaysYear')}
          />
          <RowValue
            label='Lượng nước sử dụng (m3/ngày)'
            value={this.getInitialValue('WaterUseDay')}
          />
          <RowValue
            label='Nguồn nước'
            value={this.getInitialValue('waterSource.Name')}
          />
        </React.Fragment>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Coso/CosoView/ChiTietCosoPanel/ChiTietCosoView/index.js